import { HttpEventType } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import readXlsxFile from 'read-excel-file';
import { filter, firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { UserModel } from 'src/app/models/authentication/user.model';
import { MaintenanceRoutineImportModel } from 'src/app/models/imports/maintenance-routine-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { WindowService } from 'src/app/services/authentication/window.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { MaintenanceRoutineService } from 'src/app/services/maintenance/maintenance-routine.service';
import { CompanyService } from 'src/app/services/management/company.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-maintenance-routine-import',
  templateUrl: './maintenance-routine-import.component.html',
  styleUrls: ['./maintenance-routine-import.component.scss'],
  standalone: false
})
export class MaintenanceRoutineImportComponent implements OnInit {

  companyCode: number | null = null;
  companyId: number = 0;
  eventFile: any;
  errorMaintenanceRoutine: number = 0;
  filters: ColumnResponseModel[] = [];
  formImport: FormGroup = new FormGroup({});
  isOpened: string | undefined = undefined;
  listCompanies: any[] = [];
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  maintenanceRoutineAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  nameFile: string = 'Ningún archivo seleccionado.';
  nameWindow: string = 'Importación Rutinas de Mantenimiento';
  permissionUpdatable: boolean = false;
  url: string = "maintenance-routine-import";
  userAuthenticated: UserModel = new UserModel();
  visibleTxt: boolean = false;
  projectName = ProjectName.projectName;

  private readonly formBuilder = inject(FormBuilder);
  private readonly companyService = inject(CompanyService);
  private readonly headerService = inject(HeaderService)
  private readonly maintenanceRoutineService = inject(MaintenanceRoutineService);
  private readonly router = inject(Router);
  private readonly toastHandlerService = inject(ToastHandlerService);
  private readonly title = inject(Title);
  private readonly userAuthenticatedService = inject(UserAuthenticatedService);
  private readonly windowService = inject(WindowService);

  ngOnInit() {
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    const filters = localStorage.getItem(this.url);
    if (filters) this.filters = JSON.parse(filters);
    this.headerService.setTitle(this.nameWindow);
    this.getPermission();
    this.validateForm();
    this.getAllLists();
  }

  attach() {
    document.getElementById('fileImport')?.click();
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      this.eventFile.target.value = '';
    }
  }

  downloadErrorsTxt() {
    if (!this.maintenanceRoutineAlerts || this.maintenanceRoutineAlerts.length === 0) {
      this.toastHandlerService.showToast('error', 'No hay alertas para exportar');
      return;
    }

    this.maintenanceRoutineService.exportImportErrors(this.maintenanceRoutineAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionRutinasMantenimiento_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast('error', 'Error al exportar el archivo');
      }
    });
  }

  downloadGuideImport() {
    this.maintenanceRoutineService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaRutinaMantenimiento.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  importMaintenanceRoutine() {
    this.maintenanceRoutineAlerts = [];
    this.errorMaintenanceRoutine = 0;
    this.visibleTxt = false;
    Object.keys(this.formImport.controls).forEach(key => {
      const control = this.formImport.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formImport.valid) {
      let isOk: boolean = true;
      const input = document.getElementById("fileImport") as any;
      const rowsImports = new Array<MaintenanceRoutineImportModel>();
      let row: MaintenanceRoutineImportModel;
      let counter: number = 1, articleCode: number, maintenanceRoutineState: boolean, componentCode: number, componentName: string,
        elementCode: number, elementName: string, activityCode: number, swEachUse: boolean, swMaintenancePlan1: boolean, swMaintenancePlan2: boolean,
        swMaintenancePlan3: boolean, swMaintenancePlan4: boolean, swMaintenancePlan5: boolean, swMaintenancePlan6: boolean,
        swMaintenancePlan7: boolean;
      if (input.files[0]) {
        readXlsxFile(input.files[0]).then(async (rows) => {
          if (rows.length <= 1) {
            this.toastHandlerService.showToast('warning', `El archivo ingresado no tiene registros para importar.`);
            return;
          }
          rows.splice(0, 1);

          rows.forEach(element => {
            counter = counter + 1;
            let rowHasError = false;

            //A. Código Compañía:
            const companyCode = parseFloat(element[0] as string);
            if (isNaN(companyCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}. El código de la Compañía no es válido. `;
              this.maintenanceRoutineAlerts.push(alert);
              rowHasError = true;
            } else {
              if (companyCode != this.companyCode) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}. La Compañía del archivo no es igual a la Compañía seleccionada.`;
                this.maintenanceRoutineAlerts.push(alert);
                rowHasError = true;
              }
            }

            //B. Código Artículo:
            articleCode = parseFloat(element[1] as string);
            if (isNaN(articleCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}. El código del Articulo no es válido.`;
              this.maintenanceRoutineAlerts.push(alert);
              rowHasError = true;
            }

            //C. Estado:
            if (element[2] as string != "A" && element[2] as string != "I") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna C. El campo Estado debe ser valores como: A / I.`;
              this.maintenanceRoutineAlerts.push(alert);
              rowHasError = true;
            }
            maintenanceRoutineState = element[2] as string === "I";

            //D. Código Componente:
            componentCode = parseFloat(element[3] as string);
            if (isNaN(componentCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}. El código del Componente no es válido.`;
              this.maintenanceRoutineAlerts.push(alert);
              rowHasError = true;
            }

            //E. Nombre Componente:
            componentName = element[4] as string;
            if (componentName == null || componentName == "") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}. El nombre del Componente no es válido.`;
              this.maintenanceRoutineAlerts.push(alert);
              rowHasError = true;
            } else {
              if (componentName.length > 80) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}. El nombre del Componente supera el tamaño máximo de caracteres (80).`;
                this.maintenanceRoutineAlerts.push(alert);
                rowHasError = true;
              }
            }

            //F. Código Elemento:
            elementCode = parseFloat(element[5] as string);
            if (isNaN(elementCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}. El código del Elemento no es válido.`;
              this.maintenanceRoutineAlerts.push(alert);
              rowHasError = true;
            }

            //G. Nombre Elemento:
            elementName = element[6] as string;
            if (elementName == null || elementName == "") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}. El nombre del Elemento no es válido.`;
              this.maintenanceRoutineAlerts.push(alert);
              rowHasError = true;
            } else {
              if (elementName.length > 80) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}. El nombre del Elemento supera el tamaño máximo de caracteres (80).`;
                this.maintenanceRoutineAlerts.push(alert);
                rowHasError = true;
              }
            }

            //H. Código Actividad:
            activityCode = parseFloat(element[7] as string);
            if (isNaN(activityCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}. El código de la Actividad no es válido.`;
              this.maintenanceRoutineAlerts.push(alert);
              rowHasError = true;
            }

            //I. C/Uso:
            if (element[8] as string != "S" && element[8] as string != "N") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna I. El campo C/Uso debe ser valores como: S / N.`;
              this.maintenanceRoutineAlerts.push(alert);
              rowHasError = true;
            }
            swEachUse = element[8] as string === "S";

            //J. Plan de Mantenimiento 1:
            if (element[9] as string != "S" && element[9] as string != "N") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna J. El campo Plan de Mantenimiento 1 debe ser valores como: S / N.`;
              this.maintenanceRoutineAlerts.push(alert);
              rowHasError = true;
            }
            swMaintenancePlan1 = element[9] as string === "S";

            //K. Plan de Mantenimiento 2:
            if (element[10] as string != "S" && element[10] as string != "N") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna J. El campo Plan de Mantenimiento 2 debe ser valores como: S / N.`;
              this.maintenanceRoutineAlerts.push(alert);
              rowHasError = true;
            }
            swMaintenancePlan2 = element[10] as string === "S";

            //L. Plan de Mantenimiento 3:
            if (element[11] as string != "S" && element[11] as string != "N") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna L. El campo Plan de Mantenimiento 3 debe ser valores como: S / N.`;
              this.maintenanceRoutineAlerts.push(alert);
              rowHasError = true;
            }
            swMaintenancePlan3 = element[11] as string === "S";

            //M. Plan de Mantenimiento 4:
            if (element[12] as string != "S" && element[12] as string != "N") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna M. El campo Plan de Mantenimiento 4 debe ser valores como: S / N.`;
              this.maintenanceRoutineAlerts.push(alert);
              rowHasError = true;
            }
            swMaintenancePlan4 = element[12] as string === "S";

            //N. Plan de Mantenimiento 5:
            if (element[13] as string != "S" && element[13] as string != "N") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna N. El campo Plan de Mantenimiento 5 debe ser valores como: S / N.`;
              this.maintenanceRoutineAlerts.push(alert);
              rowHasError = true;
            }
            swMaintenancePlan5 = element[13] as string === "S";

            //O. Plan de Mantenimiento 6:
            if (element[14] as string != "S" && element[14] as string != "N") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna O. El campo Plan de Mantenimiento 6 debe ser valores como: S / N.`;
              this.maintenanceRoutineAlerts.push(alert);
              rowHasError = true;
            }
            swMaintenancePlan6 = element[14] as string === "S";

            //P. Plan de Mantenimiento 7:
            if (element[15] as string != "S" && element[15] as string != "N") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna P. El campo Plan de Mantenimiento 7 debe ser valores como: S / N.`;
              this.maintenanceRoutineAlerts.push(alert);
              rowHasError = true;
            }
            swMaintenancePlan7 = element[15] as string === "S";

            if (!rowHasError) {
              row = new MaintenanceRoutineImportModel(counter, this.companyId, articleCode, maintenanceRoutineState, componentCode, componentName,
                elementCode, elementName, activityCode, swEachUse, swMaintenancePlan1, swMaintenancePlan2, swMaintenancePlan3, swMaintenancePlan4,
                swMaintenancePlan5, swMaintenancePlan6, swMaintenancePlan7);
              rowsImports.push(row);
            } else {
              isOk = false;
            }
          });
          if (isOk && rowsImports.length > 0) {
            try {
              const response = await firstValueFrom(this.maintenanceRoutineService.importMaintenanceRoutine(rowsImports));
              this.loadPreInvoicingModel = response;
              this.maintenanceRoutineAlerts = response?.alerts ?? [];
              this.errorMaintenanceRoutine = response?.preInvoicingStateId;
              if (this.errorMaintenanceRoutine === 1) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast(
                  'error',
                  'La importación terminó con errores, puede exportarlos si lo desea.',
                  'ERROR');
              } else if (this.maintenanceRoutineAlerts.length > 0) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast('error', 'La importación terminó con alertas, puede exportarlas si lo desea');
              } else {
                this.visibleTxt = false;
                this.toastHandlerService.showToast('success', `La importación terminó exitosamente.`);
              }
              this.clearInputFile();
            } catch (error) {
              this.nameFile = 'Ningún archivo seleccionado.';
              console.error('Error al importar Rutinas de Mantenimiento', error);
            }
          } else {
            this.errorMaintenanceRoutine = 1;
            this.visibleTxt = true;
            this.toastHandlerService.showToast(
              'error',
              'La importación terminó con errores, puede exportarlos si lo desea'
            );
          }
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No ha seleccionado ningún archivo.'
        });
      }
    } else {
      this.showValidationMessages();
    }
  }

  async getAllLists() {
    try {
      const [companies] = await Promise.all([
        firstValueFrom(this.companyService.getAllCompaniesForSelectAsync()),

      ]);
      this.listCompanies = companies;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  getCompany(companyId: number | null) {
    if (companyId && companyId !== 0) {
      this.companyId = companyId;
      const company = this.listCompanies.find(x => x.value === companyId);
      this.companyCode = company ? company.code : null;
    } else {
      this.companyId = 0;
      this.companyCode = null;
    }
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  async getPermission() {
    let url = this.router.url as string
    url = url.substring(1);
    this.url = url;
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos por perfil.', error);
    }
    this.getPermissionsForUserByWindow();
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(
      this.userAuthenticatedService.userObservable.pipe(
        filter(user => user && user.userId !== 0)
      )
    );
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      companyId: {
        required: 'La compañía es obligatoria.',
        min: 'La compañía es obligatiria.',
      },
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formImport.get(controlName);
      if (control && control.invalid && control.errors) {
        const errors = control.errors;
        Object.keys(errors).forEach(errorKey => {
          const message = controlMessages[controlName][errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  validateForm() {
    this.formImport = this.formBuilder.group({
      companyId: [0, [Validators.required, Validators.min(1)]],
    });
  }
}
